<template>
    <section class="no-notification">
        <div class="container">
            <div class="no-notification-icon">
                <img src="@/assets/images/no-data-img.webp" alt="no-data" loading="lazy">
            </div>
            <div class="thm-heading">
                <h3 class="no_data_text">{{$t('no-data-found','No data found')}}!</h3>
                <p v-if="message">{{message}}. </p>
            </div>
            <!-- <div class="thm-heading mt-lg-4 mt-2 data-btn">
                <a  class="thm-but ">Go back </a>
            </div> -->
        </div>
    </section>
</template>

<script>
export default {
    props:['message'],
    name: "NoDataFound",
}
</script>